// extracted by mini-css-extract-plugin
export default {"ricosContainer":"mi6PXW","actionBar":"lzxtqa"};